console.log('Brands Slider...');

const brands_slider_swiper = new Swiper('.brands-slider-swiper', {
   // Optional parameters
   direction: 'horizontal',
   speed: 400,
   loop: false,
   rewind: true,
   autoplay: {
         delay: 3000
   },
   slidesPerView: 4,
   spaceBetween: 30,
   //  slidesPerGroup: 4,
   //  centeredSlides: true, // Centra los slides activos

   // pagination: {
   //   el: ".swiper-pagination",
   //   clickable: true,
   // },
   breakpoints: {
      375: {
         slidesPerView: 3,
         spaceBetween: 24,
      },
      990: {
         slidesPerView: 3,
         spaceBetween: 24,
      },      
      1215: {
         slidesPerView: 4,
         spaceBetween: 0,
      },
      1440: {
         slidesPerView: 5,
         spaceBetween: 0,
      }
   },
   pagination: {
      el: '.brands-slider-swiper-pagination',
      clickable: true,
   },
   navigation: {
      nextEl: '.brands-slider-swiper-button-next',
      prevEl: '.brands-slider-swiper-button-prev',
   }
 });